export default {"src":"/_next/static/media/like.4c8e4e96.svg","height":70,"width":51};